import { Typography, Card } from '@mui/material';

function getMargin(index, itemsPerRow) {
  if (!itemsPerRow || itemsPerRow <= 0) {
    return '0px';
  }
  const placeInRow = index % itemsPerRow;
  if (placeInRow === 0) {
    return '0px 8px 0px 0px';
  } else if (placeInRow > 0 && placeInRow < itemsPerRow - 1) {
    return '0px 8px';
  } else if (placeInRow === itemsPerRow - 1) {
    return '0px 0px 0px 8px';
  }
  return '0px';
}

const StaticTile = ({
  backgroundColor = '#F4F8FF',
  percentage,
  text,
  itemsPerRow,
  index = 0,
}) => (
  <Card
    sx={{
      backgroundColor,
      borderRadius: '12px',
      padding: '12px 24px',
      boxShadow: 'none',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      margin: getMargin(index, itemsPerRow),
    }}
  >
    <Typography
      sx={{
        fontSize: '50px',
        fontWeight: 600,
        color: '#001030',
        textAlign: 'left',
        marginLeft: '0px',
      }}
    >
      {percentage}%
    </Typography>
    <Typography
      sx={{
        fontSize: '14px',
        fontWeight: 400,
        color: '#232B35',
        textAlign: 'left',
        marginLeft: '0px',
      }}
    >
      {text}
    </Typography>
  </Card>
);

export default StaticTile;
